import React from 'react';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-344" data-mp="324booh7b1n7j">
      <div className="max-w-4xl mx-auto text-center" data-id="element-345" data-mp="3aa12062x05t2">
        <h2 className="text-[20px] font-black mb-4 text-[#5B3FA0]" data-id="element-346" data-mp="3ablyi18shytk">
          LA SOLUCIÓN: MEGAPACK ESI SECUNDARIA
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-347" data-mp="3jah4pdbu38wv">
          Un cuadernillo completo diseñado para acompañarte durante todo el
          ciclo lectivo. Cada tema incluye actividades listas para imprimir,
          pensadas especialmente para estudiantes de secundaria. Simplemente
          elegís el tema que necesitás y la clase ya está preparada.
        </p>

        <p className="text-2xl font-black text-gray-900" data-id="element-348" data-mp="5vkw0emmflp9">
          <span className="px-2 text-[#2E9E8F] bg-[#FFFFFF]" data-id="element-349" data-mp="5w2wjngbgm2z">
            Sin perder tiempo. Sin empezar desde cero. Sin improvisar.
          </span>
        </p>
      </div>
    </section>;
}